import { X } from 'lucide-react';
import { format } from 'date-fns';

export default function QuoteDetailsModal({ quote, isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div 
        className="bg-white rounded-xl shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex justify-between items-center">
          <h2 className="text-xl font-bold text-gray-900">Quote Details</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition"
            aria-label="Close"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-6">
          {quote ? (
            <div className="space-y-6 text-sm">
              {/* Header Info */}
              <div className="grid grid-cols-2 gap-4 pb-4 border-b border-gray-200">
                <div>
                  <p className="text-xs text-gray-500 mb-1">Quote #</p>
                  <p className="font-semibold text-gray-900">
                    {quote.quote_number || `#${quote.id}`}
                  </p>
                </div>
                <div>
                  <p className="text-xs text-gray-500 mb-1">Status</p>
                  <p className="font-semibold capitalize text-gray-900">
                    {quote.status}
                  </p>
                </div>
                <div className="col-span-2">
                  <p className="text-xs text-gray-500 mb-1">Created At</p>
                  <p className="font-semibold text-gray-900">
                    {quote.created_at
                      ? format(new Date(quote.created_at), 'MMMM d, yyyy h:mm a')
                      : '-'}
                  </p>
                </div>
              </div>

              {/* Client Info */}
              <div>
                <h3 className="text-sm font-semibold text-gray-900 mb-3">Client Information</h3>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <p className="text-xs text-gray-500 mb-1">Customer Name</p>
                    <p className="font-medium text-gray-900">
                      {quote.first_name && quote.last_name
                        ? `${quote.first_name} ${quote.last_name}`
                        : quote.first_name || quote.last_name || '-'}
                    </p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500 mb-1">Email</p>
                    <p className="font-medium text-gray-900">{quote.email || '-'}</p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500 mb-1">Phone</p>
                    <p className="font-medium text-gray-900">{quote.phone || '-'}</p>
                  </div>
                </div>
              </div>

              {/* Boat Info */}
              <div>
                <h3 className="text-sm font-semibold text-gray-900 mb-3">Boat Information</h3>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <p className="text-xs text-gray-500 mb-1">Boat Type</p>
                    <p className="font-medium text-gray-900">{quote.boat_type || '-'}</p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500 mb-1">Boat Year</p>
                    <p className="font-medium text-gray-900">{quote.boat_year || '-'}</p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500 mb-1">Boat Make</p>
                    <p className="font-medium text-gray-900">{quote.boat_make || '-'}</p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500 mb-1">Boat Length</p>
                    <p className="font-medium text-gray-900">
                      {quote.boat_length ? `${quote.boat_length} ft` : '-'}
                    </p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500 mb-1">Boat Location</p>
                    <p className="font-medium text-gray-900">{quote.boat_location || '-'}</p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500 mb-1">Zip Code</p>
                    <p className="font-medium text-gray-900">{quote.zip_code || '-'}</p>
                  </div>
                </div>
              </div>

              {/* Message / Notes */}
              {quote.message && (
                <div className="pt-4 border-t border-gray-200">
                  <p className="text-xs text-gray-500 mb-2">Message</p>
                  <div className="border border-gray-200 rounded-lg p-3 bg-gray-50">
                    <p className="text-gray-800 whitespace-pre-wrap">{quote.message}</p>
                  </div>
                </div>
              )}

              {/* Empty state for message */}
              {!quote.message && (
                <div className="pt-4 border-t border-gray-200">
                  <p className="text-xs text-gray-500">No message provided</p>
                </div>
              )}
            </div>
          ) : (
            <div className="text-center py-8">
              <p className="text-sm text-gray-600">No quote details available.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

